import { AnyAction } from "redux";

const initialState = {};

const appReducer = (state = initialState, action: AnyAction) => {
  return state;
};

export default appReducer;
